"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompleteProductBuildButton = void 0;
const React = require("react");
const react_1 = require("react");
const Currency_1 = require("../../../../../../components/base/atoms/Currency");
const Button_1 = require("../../../../../../components/base/atoms/Button");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "CompleteProductBuildButton");
const CompleteProductBuildButton = ({ salesOrderItemBuilt, onCompletion, scrollToCategory, isExisting }) => {
    // categories that are missing required to be selected
    const missingRequiredSectionsMap = (0, react_1.useMemo)(() => (salesOrderItemBuilt === null || salesOrderItemBuilt === void 0 ? void 0 : salesOrderItemBuilt.missingRequiredSectionsMap) || null, [salesOrderItemBuilt]);
    // callback to complete built product and add to/update cart
    const completeBuild = (0, react_1.useCallback)(() => {
        // if all rules have passed then add item to cart
        if (salesOrderItemBuilt.isValid) {
            onCompletion(salesOrderItemBuilt);
        }
        if (missingRequiredSectionsMap === null) {
            return;
        }
        // otherwise scroll to the category section that needs to be completed
        if (missingRequiredSectionsMap.size > 0) {
            const missingCategory = [...missingRequiredSectionsMap][0][0];
            scrollToCategory(missingCategory);
        }
    }, [salesOrderItemBuilt, onCompletion, missingRequiredSectionsMap]);
    return (React.createElement(Button_1.Button, { className: css(""), onClick: completeBuild },
        React.createElement(Currency_1.Currency, null, salesOrderItemBuilt.cost),
        React.createElement("span", { className: css("text") }, isExisting ? "Update" : "Add")));
};
exports.CompleteProductBuildButton = CompleteProductBuildButton;
//# sourceMappingURL=index.js.map